"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPORT_ICON_COLORS_VIEW_DARK_THEME = exports.SPORT_ICON_COLORS_VIEW_LIGHT_THEME = void 0;
const SportColors_types_1 = require("./SportColors.types");
// TODO: Move all icons color strings to EColor enum
exports.SPORT_ICON_COLORS_VIEW_LIGHT_THEME = {
    [SportColors_types_1.ESportIconColorView.RED]: {
        main: '#E51A1A',
        background: '#FBE9E9',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.RED_1]: {
        main: '#0D0D0D',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#FBE9E9',
    },
    [SportColors_types_1.ESportIconColorView.RED_2]: {
        main: '#E51A1A',
        background: '#FEE9E7',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.RED_3]: {
        main: '#F53D3D',
        background: '#FEE9E7',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.ORANGE]: {
        main: '#FE7F00',
        background: '#FFF9E5',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.ORANGE_1]: {
        main: '#FAB267',
        background: '#F2F2F2',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BROWN]: {
        main: '#DC9E61',
        background: '#FAF2EA',
        wrapperColor: '#FAF2EA',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW]: {
        main: '#FEBF00',
        background: '#FFF9E5',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_1]: {
        main: '#98CB33',
        background: '#F5FAEB',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_1]: {
        main: '#33CB33',
        background: '#EBFAEB',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_2]: {
        main: '#3AAC3A',
        background: '#ECF8EE',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_3]: {
        main: '#19E5A1',
        background: '#E8FCEF',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_4]: {
        main: '#19E55D',
        background: '#E8FCEF',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_1]: {
        main: '#195DE5',
        background: '#E8EFFC',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_2]: {
        main: '#1919E5',
        background: '#E8E8FC',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_3]: {
        main: '#19A1E5',
        background: '#E8F6FC',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.PURPLE]: {
        main: '#A119E5',
        background: '#F6E8FC',
        wrapperColor: '#F6E8FC',
    },
    [SportColors_types_1.ESportIconColorView.BLACK]: {
        main: '#1A1A1A',
        background: '#F2F2F2',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLACK_2]: {
        main: '#222222',
        background: '#F2F2F2',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_4]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#E5F4FF',
    },
    [SportColors_types_1.ESportIconColorView.BLUE_5]: {
        main: '#0D0D0D',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#E2E7EF',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_2]: {
        main: '#FAA300',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#F8F3E2',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_3]: {
        main: '#0D0D0D',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#FFF3C8',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_4]: {
        main: '#0D0D0D',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#EDE8D7',
    },
    [SportColors_types_1.ESportIconColorView.BROWN_1]: {
        main: '#333E48',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#FFE5CC',
    },
    [SportColors_types_1.ESportIconColorView.PURPLE_1]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#F6E8FC',
    },
    [SportColors_types_1.ESportIconColorView.PURPLE_2]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#EEE8FF',
    },
    [SportColors_types_1.ESportIconColorView.GREEN]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#ECF8EE',
    },
    [SportColors_types_1.ESportIconColorView.GRAY]: {
        main: '#0D0D0D',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#E2E7EF',
    },
    [SportColors_types_1.ESportIconColorView.NONE]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GRAY_1]: {
        main: '#333E48',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#E2E7EF',
    },
};
exports.SPORT_ICON_COLORS_VIEW_DARK_THEME = {
    [SportColors_types_1.ESportIconColorView.RED]: {
        main: '#EF4848',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.RED_1]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#481A1A',
    },
    [SportColors_types_1.ESportIconColorView.RED_2]: {
        main: '#E51A1A',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.RED_3]: {
        main: '#F53D3D',
        background: '#44091E',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.ORANGE]: {
        main: '#FE7F00',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.ORANGE_1]: {
        main: '#FAB267',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BROWN]: {
        main: '#DC9E61',
        background: '#333333',
        wrapperColor: '#333333',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW]: {
        main: '#FFCF41',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_1]: {
        main: '#B7EA51',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_1]: {
        main: '#43B243',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_2]: {
        main: '#43B243',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_3]: {
        main: '#19E5A1',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.GREEN_4]: {
        main: '#19E55D',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_1]: {
        main: '#4E7FFF',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_2]: {
        main: '#4E7FFF',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_3]: {
        main: '#5EC9FF',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_5]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#122C5A',
    },
    [SportColors_types_1.ESportIconColorView.PURPLE]: {
        main: '#B447EB',
        background: '#340F47',
        wrapperColor: '#340F47',
    },
    [SportColors_types_1.ESportIconColorView.BLACK]: {
        main: '#FFFFFF',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLACK_2]: {
        main: '#FFFFFF',
        background: '#333333',
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.NONE]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: SportColors_types_1.EColor.EMPTY,
    },
    [SportColors_types_1.ESportIconColorView.BLUE_4]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#122C5A',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_2]: {
        main: '#FAAB18',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#4D3E00',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_3]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#353227',
    },
    [SportColors_types_1.ESportIconColorView.YELLOW_4]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#3C3829',
    },
    [SportColors_types_1.ESportIconColorView.BROWN_1]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#613000',
    },
    [SportColors_types_1.ESportIconColorView.PURPLE_1]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#340F47',
    },
    [SportColors_types_1.ESportIconColorView.PURPLE_2]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#20104A',
    },
    [SportColors_types_1.ESportIconColorView.GREEN]: {
        main: SportColors_types_1.EColor.EMPTY,
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#1C3A1C',
    },
    [SportColors_types_1.ESportIconColorView.GRAY]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#303848',
    },
    [SportColors_types_1.ESportIconColorView.GRAY_1]: {
        main: '#FFFFFF',
        background: SportColors_types_1.EColor.EMPTY,
        wrapperColor: '#303848',
    },
};
//# sourceMappingURL=constants.js.map